<template>
  <div class="card shadow-sm mb-4">
    <div class="card-header bg-accent">
      <h4 class="mb-0 text-white fs-1vw">مدارک و رشته تحصیلی</h4>
    </div>
    <div class="card-body">
      <div class="study-row">
        <div>
          <label class="form-label fw-bold">مقطع تحصیلی</label>
          <select class="form-select" v-model="newStudyField.degree">
            <option value="" disabled>مقطع تحصیلی را انتخاب کنید</option>
            <option :value="degree" v-for="(degree, index) in degrees" :key="index">
              {{ degree }}
            </option>
          </select>
        </div>
        <div>
          <label class="form-label fw-bold">رشته تحصیلی</label>
          <input
              type="text"
              class="form-control"
              placeholder="رشته تحصیلی را وارد کنید"
              v-model="newStudyField.field"
          />
        </div>
        <div>
          <label class="form-label fw-bold">گرایش</label>
          <input
              type="text"
              class="form-control"
              placeholder="گرایش را وارد کنید"
              v-model="newStudyField.specialization"
          />
        </div>
        <div>
          <GeneralButton @clicked="addStudyField"/>
        </div>
      </div>
      <hr class="my-3">

      <!-- StudyFields Table -->
      <GeneralTable
          :headers="['مقطع تحصیلی', 'رشته تحصیلی', 'گرایش']"
          :fields="['degree', 'field', 'specialization']"
          :items="jobQualification.study_fields"
          :openEditModalMethod="openEditModal"
          @remove="removeStudyField"
      />

      <!-- Edit StudyField Modal -->
      <GeneralModal
          v-show="editedStudyField"
          title="ویرایش مدرک تحصیلی"
          modal-id="studyModalId"
          @save="updateStudyField"
      >
        <div class="row mb-3">
          <div class="col-md-4">
            <label class="form-label fw-bold">مقطع تحصیلی</label>
            <select class="form-select" v-if="editedStudyField" v-model="editedStudyField.degree">
              <option value="" disabled>مقطع تحصیلی را انتخاب کنید</option>
              <option :value="degree" v-for="(degree, index) in degrees" :key="index">
                {{ degree }}
              </option>
            </select>
          </div>
          <div class="col-md-4">
            <label class="form-label fw-bold">رشته تحصیلی</label>
            <input
                type="text"
                class="form-control"
                placeholder="رشته تحصیلی را وارد کنید"
                v-if="editedStudyField"
                v-model="editedStudyField.field"
            />
          </div>
          <div class="col-md-4">
            <label class="form-label fw-bold">گرایش</label>
            <input
                type="text"
                class="form-control"
                placeholder="گرایش را وارد کنید"
                v-if="editedStudyField"
                v-model="editedStudyField.specialization"
            />
          </div>
        </div>
      </GeneralModal>
    </div>
  </div>
</template>

<script>
import GeneralTable from "@/components/JobDescription/GeneralComponents/GeneralTable.vue";
import GeneralModal from "@/components/JobDescription/GeneralComponents/GeneralModal.vue";
import {Modal} from 'bootstrap';
import {useToast} from "vue-toastification";
import GeneralButton from "@/components/JobDescription/GeneralComponents/GeneralButton.vue";

const baseStructure = {
  degree: "",
  field: "",
  specialization: ""
}
const toast = useToast();

export default {
  components: {GeneralButton, GeneralTable, GeneralModal},
  data() {
    return {
      newStudyField: structuredClone(baseStructure),
      degrees: ['دیپلم', 'کارشناسی', 'کارشناسی ارشد', 'دکتری'],
      editedStudyField: null,
      editIndex: null,
    };
  },
  computed: {
    jobQualification: {
      get() {
        return this.$store.state.jobQualification.jobQualification;
      },
    }
  },
  methods: {
    async addStudyField() {
      if (!this.newStudyField.degree || !this.newStudyField.field || !this.newStudyField.specialization) {
        toast.error('همه فیلدها را کامل وارد کنید!');
        return;
      }

      const response = await this.$store.dispatch('crudActions/create', {
        resourceData: this.newStudyField,
        endpoint: '/job-qualifications/store-study-field',
      })

      this.jobQualification.study_fields = [...this.jobQualification.study_fields, structuredClone(response.data)];
      this.newStudyField = structuredClone(baseStructure);
    },
    removeStudyField(index) {
      const studyField = this.jobQualification.study_fields.find((_, i) => i === index);
      this.jobQualification.study_fields = this.jobQualification.study_fields.filter((_, i) => i !== index);

      this.$store.dispatch('crudActions/delete', {
        resourceId: studyField.id,
        endpoint: '/job-qualifications/delete-study-field',
      })
    },
    openEditModal(studyField, index) {
      this.editedStudyField = structuredClone(studyField);
      this.editIndex = index;
      const modal = Modal.getOrCreateInstance(document.getElementById('studyModalId'));
      modal.show();
    },
    updateStudyField() {
      if (this.editIndex === null) {
        return;
      }

      if (!this.editedStudyField.degree || !this.editedStudyField.field || !this.editedStudyField.specialization) {
        toast.error('همه فیلدها را کامل وارد کنید!');
        return;
      }

      this.jobQualification.study_fields.splice(this.editIndex, 1, {...this.editedStudyField});

      this.$store.dispatch('crudActions/update', {
        resourceData: this.editedStudyField,
        endpoint: '/job-qualifications/update-study-field',
      })

      this.editIndex = null;
      this.editedStudyField = null;
      const modal = Modal.getOrCreateInstance(document.getElementById('studyModalId'));
      modal.hide();
    }
  },
};
</script>
